module.exports = __webpack_public_path__ + "../assets/dekstop-3.jpg";